// extracted by mini-css-extract-plugin
export default {"box":"ServiceHome_box__rFQu8","hovered":"ServiceHome_hovered__c06rJ","heading":"ServiceHome_heading__V-d2f","text":"ServiceHome_text__CmsRT","to":"ServiceHome_to__RLW1w"};